import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Response } from '../models/response';
import { HttpContextConfig } from '../models/http-context-config';
import { CONFIG } from '../interceptors/loader.interceptor';

const reviewURL = `${environment.api}/reviews`;
const reportURL = `${environment.api}/survey`;

@Injectable({
  providedIn: 'root'
})
export class ReviewService {
  constructor(private readonly http: HttpClient) {}

  getReview(month: any, year: any, chosenUser: string) {
    return of({ result: null });
  }

  addReview(review: string): Observable<Response<any>> {
    return of({ result: { review } } as Response<any>);
  }

  updateReview(review: string, id: any): Observable<Response<any>> {
    return of({ result: { id, review } } as Response<any>);
  }

  addHowIsGoing(
    how_is_going: string,
    month: string,
    year: string
  ): Observable<Response<any>> {
    return of({
      result: {
        how_is_going,
        month,
        year
      }
    } as Response<any>);
  }

  updateHowIsGoing(how_is_going: string, id: any): Observable<Response<any>> {
    return of({ result: { id, how_is_going } } as Response<any>);
  }

  setReviewCompleted(chosen_user: string, month: any, year: any) {
    return of({
      result: {
        chosen_user,
        month,
        year
      }
    });
  }

  switchPartialReviewCompleted(
    is_partial_completed: boolean,
    is_draft: boolean,
    chosen_user: string,
    month: any,
    year: any,
    is_transversal?: number
  ) {
    return of({
      result: {
        is_partial_completed,
        is_draft,
        is_transversal,
        chosen_user,
        month,
        year
      }
    } as unknown as Response<any>);
  }

  /*   updateReview(id:number , how_is_going:string) : Observable<Response<any>> {
   return this.http.put<any>(this.serviceURL+'/manage/' + id, {how_is_going} );
 } */

  /**
   * Questa funzione serve per prendere il come sta andando/ cosa pensiamo di te se ne esiste uno gia salvato
   * @param id passare l'id se stiamo facendo la review ad un altro utente
   * @returns come sta andando/cosa pensiamo di te
   */
  getReviewHowIsGoing(
    id?: string,
    selectedReviewId?: string | number
  ): Observable<any> {
    let config = new HttpContextConfig();
    config.noSpinner = true;

    let URL = `${reviewURL}/getReviewHowIsGoing`;
    if (id) URL += `/${id}`;

    let params = new HttpParams();
    if (selectedReviewId) {
      params = params.set('review_id', selectedReviewId.toString());
    }

    return of({ result: null });
  }

  /**
   * funzione che serve per salvare il come sta andando/cosa pensiamo di te che si trova nella sezione Review
   * @param dataHowIsGoing oggetto che puo contenere un id, dell'utente a cui stiamo facendo la review, e il testo della review
   * stessa
   */
  reviewHowIsGoing(dataHowIsGoing: any): Observable<any> {
    return of({ result: dataHowIsGoing });
  }

  /**
   * Questa funzione serve per settare il reveals su come sta andando/cosa pensiamo di te
   * @param id serve per capire se stiamo settando il reveals su un cosa pensiamo di te, se non passaimo l'id lo stiamo settando al
   * come sta andando
   * @returns
   */
  setReveals(id?: string): Observable<any> {
    let config = new HttpContextConfig();
    config.noSpinner = true;
    let URL;
    if (id) {
      URL = `${reviewURL}/reveals/` + id;
    } else {
      URL = `${reviewURL}/reveals`;
    }
    return of({ result: null });
  }

  /**
   * Service per salvare una review dopo aver completato l'how-is-going
   */
  saveReview(userId: any): Observable<any> {
    return of({ result: userId });
  }

  /**
   * ottengo la lista delle review dell'utente
   */
  getReviewHistorical(chosenUser?: string) {
    let params = new HttpParams();

    if (chosenUser) {
      params = params.set('chosen_user', chosenUser);
    }

    return of({ result: [] });
  }

  getUserReport(reviewId: number): Observable<any> {
    return of({ result: null });
  }
}
